<template>
    <div class="main">
        <topback title="Invite Reward" path="back"></topback>

        <md-field class="mt-6">
            <md-field-item solid title="Code" class="copy" :data-clipboard-text="invite_link.referral_code" :content="invite_link.referral_code" addon="Copy" @click="onCopy" />
            <md-field-item solid title="Link" class="copy" :data-clipboard-text="link" addon="Copy" @click="onCopy" >
                <div slot="default" class="title">{{link}}</div>
            </md-field-item>
        </md-field>

        <md-field style="padding-top: 0rem;">
            <md-cell-item title="Overview" @click="illustrate">
                <md-tag
                    slot="right"
                    size="large"
                    shape="bubble"
                    fill-color="linear-gradient(90deg, #FF5B60 0%, #F98472 100%)"
                    type="fill"
                > ? </md-tag>
                <div slot="children">
                    <table class="profit-table">
                        <thead>
                            <tr>
                                <th>Level</th>
                                <th>No.of</th>
                                <th>buy Itoken</th>
                                <th>Reward</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><iconimg name="A" size="lg"></iconimg></td>
                                <td>{{ teaminfothree.one_count }}</td>
                                <td>{{ teaminfothree.one_total_recharge }}</td>
                                <td>Itoken {{ teaminfothree.one_commission }}</td>
                            </tr>
                            <tr>
                                <td><iconimg name="B" size="lg"></iconimg></td>
                                <td>{{ teaminfothree.two_count }}</td>
                                <td>{{ teaminfothree.two_totalrecharge }}</td>
                                <td>Itoken {{ teaminfothree.two_commission }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </md-cell-item>

            <md-cell-item title="Today">
                <div slot="children">
                    <table class="profit-table">
                        <thead>
                            <tr>
                                <th>Level</th>
                                <th>No.of</th>
                                <th>buy Itoken</th>
                                <th>Reward</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><iconimg name="A" size="lg"></iconimg></td>
                                <td>{{ teaminfothree.today_one_count }}</td>
                                <td>{{ teaminfothree.today_one_total_recharge }}</td>
                                <td>{{ teaminfothree.today_one_commission }}</td>
                            </tr>
                            <tr>
                                <td><iconimg name="B" size="lg"></iconimg></td>
                                <td>{{ teaminfothree.today_two_count }}</td>
                                <td>{{ teaminfothree.today_two_totalrecharge }}</td>
                                <td>{{ teaminfothree.today_two_commission }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </md-cell-item>
        </md-field>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import Clipboard from "clipboard"
import { Dialog } from 'mand-mobile'
import { referral, teaminfothree } from '@/request/api'

export default {
    name: 'invite',
    components: {
        [topback.name]: topback,
        iconimg,
        Clipboard
    },
    data() {
        return {
            invite_link: {},
            link: "",
            teaminfothree: {},
            third_level_init_bonus_rates: 0,
            level_1: 0,
            level_2: 0,
        }
    },
    watch: {

    },
    created() {
        this.$store.dispatch('asyncupdateuserinfo');
        this.$store.dispatch("asyncupdatesiteconfig").then(res=>{
            let clr_settings = JSON.parse(res.cw_level_reward_settings);
            this.third_level_init_bonus_rates = clr_settings.third_level_init_bonus_rates;
            this.level_1 = clr_settings.third_level_commission_settings["1"];
            this.level_2 = clr_settings.third_level_commission_settings["2"];
            this.get_invite();
        });
        this.get_teaminfothree();
    },
    methods: {
        get_teaminfothree() {
            teaminfothree().then(res=>{
                if(res.code === 200) {
                    this.teaminfothree = res.data;
                }
            })
        },
        get_invite() {
            referral().then(res => {
                if(res.code === 200) {
                    this.invite_link = res.data[0];
                    this.link = this.$store.state.siteconfig.cw_register_host + '/#/rs/' + this.invite_link.referral_code;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            }).catch(() => {
                
            });
        },
        onCopy() {
            let clipboard = new Clipboard('.copy')
			clipboard.on('success', () => {
				this.$toast.succeed('copy successfully',1000);
				clipboard.destroy()
			})
			clipboard.on('error', () => {
				this.$toast.failed("Browser does not support copying",2000)
				clipboard.destroy()
			})
        },
        illustrate() {
            Dialog.alert({
                title: 'Tipp',
                content: 'You recommend A-level members to buy Itoken and you will get a ' + this.level_1 + '% reward <br><br>Your B-level members recommended by your A-level members will get ' + this.level_2 + '% reward for buying Itoken',
                confirmText: 'Got it',
                onConfirm: () => {},
            })
        }
    }

}
</script>


<style scoped>
.title{ 
    width:300px; 
    white-space:nowrap; 
    overflow:hidden; 
    text-overflow:ellipsis;
}
.profit-table {
  width: 100%;
  text-align: center;
}
.profit-table tr {
  height: 0.63rem;
  color: black;
  font-size: 0.18rem;
}
.invite_btn {
    width: 1.75rem;
    height: 0.82rem;
}
.link >>> .md-field-item-control {
    max-width: 2.7rem;
    overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/my/invite.vue